import Vue from 'vue'
import App from './App.vue'
import Axios from "axios";
import vuetify from "./plugins/vuetify";
import router from "./router";
import './plugins';
import store from './store';
import { sync } from 'vuex-router-sync';
import VueGtag from "vue-gtag";
import FlashMessage from '@smartweb/vue-flash-message';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';

Vue.use(VueFilterDateFormat);
Vue.use(VueSweetalert2);

Vue.config.productionTip = false;

sync(store, router)

Vue.prototype.$http = Axios;
const token = localStorage.getItem("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    "Bearer " + token;
}

Vue.prototype.$http.interceptors.response.use(undefined, function(err) {
  if (
    err.response &&
    err.response.status === 401 &&
    err.response.config &&
    !err.response.config.__isRetryRequest
  ) {
    store.dispatch("auth/logout");
    router.push('/login');
  }
  throw err;
});

Vue.use(
  VueGtag,
  {
    config: { id: process.env.VUE_APP_GOOGLE_TAG },
    includes: [{ id: process.env.VUE_APP_GOOGLE_TAG_GA4 }]
  },
  router
);
Vue.use(FlashMessage, {
  name: "flashMessage",
  tag: "FlashMessage",
  time: 6000,
  strategy: "single"
});

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
